export default __webpack_public_path__ + "static/feature-banner-tokyo-4a0f17e2ece96de03fcd39f9a7390635.jpg";